module.exports = __webpack_public_path__ + "static/media/green-food-beverage-producer-awards-img.b0d40d28.png";